import { VALUE_PERCENTAGE_TYPE } from '@/constants';

export const isPercent = (type) => type === VALUE_PERCENTAGE_TYPE;
